import { fillLevelSensorTypesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("fill-level-sensor-type"),
  endpoint: "fill-level-sensor-types",
  operations: fillLevelSensorTypesOps,
  roleView: [ROLE.FILL_SENSOR_VIEW, ROLE.FILL_SENSOR_ADMIN],
  roleAdmin: [ROLE.FILL_SENSOR_ADMIN],

  singularName: (t) => t("Fill Level Sensor type"),
  name: (t) => t("Fill Level Sensor types"),
  syncCustomerFilter: true,
});

export default conf;
